import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'

// Cargar script de tracking
;
(function () {
  const t = document.createElement('script');
  t.type = 'text/javascript';
  t.src = 'https://trk.chefalessandra.com/track.js';
  document.head.appendChild(t);
})();

// Microsoft Clarity
;
(function (c: any, l: any, a: any, r: any, i: any, t: any, y: any) {
  c[a] = c[a] || function () {
    (c[a].q = c[a].q || []).push(arguments);
  };
  t = l.createElement(r);
  t.async = 1;
  t.src = 'https://www.clarity.ms/tag/' + i;
  y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, 'clarity', 'script', 'vwa08bw655', null, null);

// Facebook Pixel
;
(function () {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '4421750054811824');
  window.fbq('track', 'PageView');
})();
render(<App data-id="element-265" />, document.getElementById('root'));